import { ScanField } from "@/components/ScanField";
// The answer to what was scanned belongs to the screen that opened this overlay (it is the one
// that knows whether the code was right), and it comes from the one shared piece: @/lib/scanFeedback.
import { ServerStatusBar } from "@/components/ServerStatus";
import { useEffect } from "react";
import { X } from "lucide-react";

// Full-screen follow-up scan surface (destination bin, fresh tag, part to add). Solid
// white (blueprint: no transparent overlays), big close target, camera auto-starts.
export function FloorScanOverlay({ open, title, sub, submitLabel = "Scan", onScan, onClose, busy, testid = "floor-scan-overlay", continuous = false }) {
  // Escape backs out (tablet keyboards / desk QA) — the big X remains the primary affordance.
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div data-testid={testid} className="fixed inset-x-0 top-vv h-vv z-[85] bg-white flex flex-col">
      {/* This surface covers the shell, so the outage bar is mounted HERE too — a tech scanning
          during a wifi drop must not be the only person in the building who can't see it. */}
      <ServerStatusBar />
      <div className="h-20 flex items-center justify-between px-6 border-b border-[#E2E8F0] shrink-0">
        <div className="min-w-0">
          <div className="text-2xl font-black tracking-tight truncate">{title}</div>
          {sub && <div className="text-base text-slate-500 font-medium truncate">{sub}</div>}
        </div>
        <button type="button" data-testid={`${testid}-close`} onClick={onClose}
          className="w-16 h-16 rounded-xl border-2 border-[#E2E8F0] flex items-center justify-center active:scale-95 active:bg-slate-100 transition-[transform,background-color] duration-100 shrink-0 ml-4">
          <X className="w-8 h-8" strokeWidth={2.2} />
        </button>
      </div>
      <div className="flex-1 p-6 overflow-y-auto">
        <ScanField testid={`${testid}-field`} label={title} submitLabel={submitLabel}
          onScan={onScan} busy={busy} autoStartCamera continuous={continuous} />
      </div>
    </div>
  );
}
